module.exports = __webpack_public_path__ + "static/img/ent-7.2948886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-7.jpg
// module id = Inrl
// module chunks = 52